// Service 24 — ประกันภัย / ประกันสุขภาพสำหรับชาวต่างชาติและเอกสารประกันภัย
// อ้างอิงหลัก: สำนักงานคณะกรรมการกำกับและส่งเสริมการประกอบธุรกิจประกันภัย (คปภ.) oic.or.th, สายด่วน 1186,
// ป.พ.พ. บรรพ 3 ลักษณะ 20 ประกันภัย มาตรา 861–897 (การเปิดเผยข้อความจริง ม.865 อายุความ ม.882),
// พ.ร.บ.ประกันชีวิต พ.ศ. 2535 และ พ.ร.บ.ประกันวินาศภัย พ.ศ. 2535,
// พ.ร.บ.คุ้มครองผู้ประสบภัยจากรถ พ.ศ. 2535 (ประกัน พ.ร.บ.) และกฎกระทรวงกำหนดค่าเสียหายเบื้องต้น,
// ประกาศเงื่อนไขประกันสุขภาพวีซ่า Non-O-A / Non-O-X และระบบตรวจสอบกรมธรรม์ longstay.tgia.org
// (สมาคมประกันวินาศภัยไทย), หลักเกณฑ์วีซ่า LTR โดย BOI (ltr.boi.go.th),
// สำนักงานประกันสังคม (sso.go.th) มาตรา 33/39/40, สำนักงานหลักประกันสุขภาพแห่งชาติ (nhso.go.th),
// สำนักงานตรวจคนเข้าเมือง (immigration.go.th) และกรมการกงสุล (consular.mfa.go.th) สำหรับรับรองเอกสารเคลม
// Client-safe definitions only.

export type InsuranceFaqCategory =
  | "visa-health-insurance"
  | "policy-law-basics"
  | "claims-documents"
  | "motor-insurance"
  | "travel-insurance"
  | "social-security"
  | "property-liability"
  | "complaints-regulator";

export interface InsuranceCategoryDef {
  slug: InsuranceFaqCategory;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  matchTh: RegExp;
  matchEn: RegExp;
}

export const INSURANCE_FAQ_CATEGORIES: InsuranceCategoryDef[] = [
  {
    slug: "visa-health-insurance",
    titleTh: "ประกันสุขภาพเพื่อยื่นวีซ่า Non-O-A / O-X / LTR",
    titleEn: "Health insurance for Non-O-A, O-X and LTR visas",
    descTh:
      "เงื่อนไขประกันสุขภาพที่ประกาศกำหนดสำหรับวีซ่าพำนักระยะยาว ทุนประกันขั้นต่ำที่ต้องตรวจจากประกาศฉบับที่ใช้บังคับ การตรวจสอบกรมธรรม์ผ่านระบบ longstay.tgia.org ทางเลือกสำหรับ LTR และเอกสารกรมธรรม์ที่ ตม. ยอมรับ",
    descEn:
      "The insurance conditions published for long-stay visas, the minimum sums you must read from the notification currently in force, verifying policies through longstay.tgia.org, the LTR alternatives, and the policy documents Immigration accepts.",
    matchTh: /Non-O-A|O-X|LTR|ตรวจลงตรา|longstay|ต่ออายุการพำนัก/i,
    matchEn: /Non-O-A|O-X|LTR|longstay|extension of stay/i,
  },
  {
    slug: "policy-law-basics",
    titleTh: "กฎหมายสัญญาประกันภัยที่ต้องรู้ก่อนเซ็น",
    titleEn: "Insurance contract law you should know before signing",
    descTh:
      "สัญญาประกันภัยตาม ป.พ.พ. มาตรา 861–897 หน้าที่เปิดเผยข้อความจริงตามมาตรา 865 ผลของการปิดบังประวัติสุขภาพ ระยะเวลาที่ไม่คุ้มครองโรคที่เป็นมาก่อน การต่ออายุ และอายุความเรียกค่าสินไหมทดแทน 2 ปีตามมาตรา 882",
    descEn:
      "Insurance contracts under sections 861–897 of the Civil and Commercial Code, the duty of disclosure in section 865, the effect of hiding a medical history, pre-existing condition waiting periods, renewal, and the two-year limitation period in section 882.",
    matchTh: /ป\.พ\.พ|มาตรา 865|มาตรา 882|เปิดเผยข้อความจริง|โรคที่เป็นมาก่อน|โฆษะ|บอกล้าง|อายุความ/i,
    matchEn: /section 865|section 882|disclosure|pre-existing|voidable|limitation period|contract law/i,
  },
  {
    slug: "claims-documents",
    titleTh: "เอกสารเคลมและการรับรองเอกสารประกันภัยข้ามประเทศ",
    titleEn: "Claim documents and legalising insurance paperwork abroad",
    descTh:
      "ชุดเอกสารเคลมค่ารักษาพยาบาล ใบรับรองแพทย์และใบเสร็จที่บริษัทประกันต่างประเทศต้องการ การแปลและรับรองนิติกรณ์ที่กรมการกงสุล การรับรองสำเนาโดยทนายความ Notarial Services Attorney และหนังสือมอบอำนาจให้ดำเนินการเคลมแทน",
    descEn:
      "The claim pack for medical expenses, medical certificates and receipts foreign insurers require, translation and legalisation at the Department of Consular Affairs, notarised copies by a Notarial Services Attorney, and powers of attorney to file a claim for you.",
    matchTh: /เคลม|ใบรับรองแพทย์|ใบเสร็จ|นิติกรณ์|รับรองคำแปล|มอบอำนาจ|เวชระเบียน/i,
    matchEn: /claim|medical certificate|receipt|legalis|translation|power of attorney|medical record/i,
  },
  {
    slug: "motor-insurance",
    titleTh: "ประกัน พ.ร.บ. และประกันรถภาคสมัครใจ",
    titleEn: "Compulsory motor insurance and voluntary car cover",
    descTh:
      "ประกันภัยรถตาม พ.ร.บ.คุ้มครองผู้ประสบภัยจากรถ พ.ศ. 2535 ค่าเสียหายเบื้องต้นตามกฎกระทรวงที่ใช้บังคับ ความต่างของประกันชั้น 1/2+/3+ การใช้ใบขับขี่ต่างชาติกับความคุ้มครอง และเอกสารเมื่อเกิดอุบัติเหตุ",
    descEn:
      "Compulsory motor cover under the Protection for Motor Vehicle Accident Victims Act B.E. 2535, the initial compensation set by the ministerial regulation in force, the difference between class 1, 2+ and 3+ cover, driving licences and cover, and accident paperwork.",
    matchTh: /พ\.ร\.บ\.คุ้มครองผู้ประสบภัย|ประกันรถ|ชั้น 1|ชั้น 2\+|ชั้น 3|อุบัติเหตุทางถนน|มอเตอร์ไซค์|ใบขับขี่/i,
    matchEn: /motor|car insurance|class 1|road accident|motorcycle|driving licen/i,
  },
  {
    slug: "travel-insurance",
    titleTh: "ประกันเดินทางและประกันวีซ่าเชงเกน",
    titleEn: "Travel insurance and Schengen visa cover",
    descTh:
      "เงื่อนไขประกันเดินทางที่สถานทูตกลุ่มเชงเกนกำหนดทุนคุ้มครองไม่น้อยกว่า 30,000 ยูโร ครอบคลุมค่ารักษาและค่าส่งกลับ การระบุประเทศและช่วงวันที่ให้ตรงกับตั๋วเดินทาง ประกันสำหรับผู้สูงอายุ และประกันเดินทางสำหรับวีซ่าประเทศอื่น",
    descEn:
      "Travel insurance conditions for Schengen visas requiring cover of at least EUR 30,000 including medical treatment and repatriation, matching territory and dates to your tickets, cover for older travellers, and travel insurance for other visa types.",
    matchTh: /ประกันเดินทาง|เชงเกน|30,000 ยูโร|ส่งกลับ|ตั๋วเครื่องบิน|ท่องเที่ยว/i,
    matchEn: /travel insurance|Schengen|EUR 30,000|repatriation|trip|tourist/i,
  },
  {
    slug: "social-security",
    titleTh: "ประกันสังคมของชาวต่างชาติและสิทธิรักษาพยาบาล",
    titleEn: "Social security for foreigners and healthcare entitlements",
    descTh:
      "การเป็นผู้ประกันตนมาตรา 33 สำหรับลูกจ้างต่างชาติที่มีใบอนุญาตทำงาน การรักษาสิทธิด้วยมาตรา 39 ทางเลือกมาตรา 40 การเลือกโรงพยาบาลตามบัตรรับรองสิทธิ และการใช้สิทธิประกันสังคมร่วมกับประกันเอกชน",
    descEn:
      "Insured-person status under section 33 for foreign employees with a work permit, continuing cover under section 39, the section 40 option, choosing your contracted hospital, and combining social security with private cover.",
    matchTh: /ประกันสังคม|มาตรา 33|มาตรา 39|มาตรา 40|บัตรรับรองสิทธิ|สปส|นายจ้าง/i,
    matchEn: /social security|section 33|section 39|section 40|contracted hospital|employer contribution/i,
  },
  {
    slug: "property-liability",
    titleTh: "ประกันอัคคีภัยบ้าน-คอนโดและประกันความรับผิดต่อบุคคลภายนอก",
    titleEn: "Home and condo fire cover and third-party liability",
    descTh:
      "ประกันอัคคีภัยที่ธนาคารกำหนดเป็นเงื่อนไขสินเชื่อ ความคุ้มครองภัยธรรมชาติ การประกันทรัพย์สินในห้องชุดกับส่วนกลางของนิติบุคคลอาคารชุด ประกันความรับผิดต่อบุคคลภายนอกสำหรับผู้ให้เช่า และผู้รับประโยชน์ในกรมธรรม์",
    descEn:
      "Fire insurance banks require as a loan condition, natural-peril extensions, the split between unit contents and the juristic person's common-area policy, third-party liability for landlords, and naming beneficiaries.",
    matchTh: /อัคคีภัย|ทรัพย์สิน|นิติบุคคลอาคารชุด|ผู้รับประโยชน์|ความรับผิดต่อบุคคลภายนอก|สินเชื่อ|น้ำท่วม/i,
    matchEn: /fire insurance|property|juristic person|beneficiary|third-party liability|mortgage|flood/i,
  },
  {
    slug: "complaints-regulator",
    titleTh: "ปฏิเสธเคลม ร้องเรียน คปภ. และการระงับข้อพิพาท",
    titleEn: "Declined claims, OIC complaints and dispute resolution",
    descTh:
      "ขั้นตอนเมื่อบริษัทปฏิเสธหรือประวิงการจ่ายค่าสินไหม การร้องเรียนสายด่วน คปภ. 1186 การไกล่เกลี่ยข้อพิพาทด้านประกันภัยและอนุญาโตตุลาการตามระเบียบ คปภ. การฟ้องศาล และการเตรียมพยานหลักฐาน",
    descEn:
      "What to do when an insurer declines or delays a claim, complaining through the OIC 1186 hotline, OIC mediation and arbitration, litigation, and assembling evidence.",
    matchTh: /ปฏิเสธ|ร้องเรียน|คปภ|1186|ไกล่เกลี่ย|อนุญาโตตุลาการ|ฟ้อง|ข้อพิพาท/i,
    matchEn: /declin|complain|OIC|1186|mediation|arbitration|sue|dispute/i,
  },
];

export function getInsuranceCategoryDef(slug: string): InsuranceCategoryDef | undefined {
  return INSURANCE_FAQ_CATEGORIES.find((c) => c.slug === slug);
}